import styled from 'styled-components';
import { Button as uikitButton } from 'components/uikit/Button/Button';

export const OpenMenuButton = styled(uikitButton).attrs(() => ({ theme: 2, size: 's' }))`
  width: 32px;
  height: 32px;
`;

export const Menu = styled.div`
  display: flex;
  width: 364px;
  flex-direction: column;
  position: absolute;
  right: 20px;
  margin-top: 4px;
  padding: 4px;
  background-color: var(--color-white);
  border-radius: 12px;
  box-shadow: var(--shadow-1);
  z-index: 3;
`;

export const MenuItem = styled.a`
  display: flex;
  align-items: center;
  font: var(--font-regular-15);
  height: 44px;
  text-decoration: none;
  color: var(--color-black);
  border-radius: 12px;
  padding: 12px;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    color: var(--color-black);
    background-color: var(--color-grey-1);
  }
`;

export const Wraper = styled.div``;
